import { Button, Space } from "antd";
import React from "react";
import * as XLSX from "xlsx";

const XLSXReader = ({
  setShowProductSearchDrawer,
  setDataSource,
  dataSource,
}) => {
  const inputRef = React.useRef(null);

  const findInvalidFields = React.useCallback(
    ({
      boq_item,
      hsn_code,
      brand,
      mrp,
      unit_selling_price,
      quantity,
      unit,
      gross_margin,
      tax_value,
    }) => {
      const errors = [];

      if (!boq_item) {
        errors.push("boq_item");
      }
      if (isNaN(mrp) && mrp !== "") {
        errors.push("mrp");
      }
      if (isNaN(unit_selling_price) && unit_selling_price !== "") {
        errors.push("unit_selling_price");
      }
      if (isNaN(quantity) && quantity !== "") {
        errors.push("quantity");
      }
      if (isNaN(gross_margin) && gross_margin !== "") {
        errors.push("gross_margin");
      }
      if (isNaN(tax_value) && tax_value !== "") {
        errors.push("tax_value");
      }

      return errors;
    },
    []
  );

  const handleFile = React.useCallback(
    (file) => {
      const reader = new FileReader();
      reader.onload = (evt) => {
        /* Parse data */
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        const errArr = [];

        try {
          const processed = data.slice(1).map((item, idx) => {
            const [
              boq_item,
              hsn_code,
              brand,
              mrp,
              unit_selling_price,
              quantity,
              unit,
              gross_margin,
              tax_value,
            ] = item;

            const errors = findInvalidFields({
              boq_item,
              hsn_code,
              brand,
              mrp,
              unit_selling_price,
              quantity,
              unit,
              gross_margin,
              tax_value,
            });

            if (errors.length > 0) {
              // eslint-disable-next-line no-throw-literal
              throw {
                row: idx,
                errors,
              };
            }

            return {
              id: dataSource?.length > 0 ? dataSource?.length + idx : idx,
              boq_item,
              hsn_code,
              brand,
              mrp: mrp ?? "0",
              unit_selling_price: unit_selling_price ?? "0",
              md_price_gst: unit_selling_price * 1.18 ?? "0",
              quantity: quantity ?? "1",
              unit: unit ?? "sqft",
              gross_margin: gross_margin ?? "0",
              margin: gross_margin / (1 - gross_margin / 100) ?? 0,
              tax_value: tax_value ?? "18",
              tax_type: "cgst_sgst",
              image: null,
            };
          });

          setDataSource([...dataSource, ...processed]);
          console.log("debug>>> data", [...dataSource, ...processed]);
          setShowProductSearchDrawer(false);
        } catch (error) {
          errArr.push(error);
        }

        if (errArr.length > 0) {
          console.log("debug>>> errArr", errArr);
        }
      };
      reader.readAsBinaryString(file);
    },
    [dataSource, findInvalidFields, setDataSource, setShowProductSearchDrawer]
  );

  return (
    <Space>
      <Space direction="vertical" justify="center" align="center">
        <Button onClick={() => inputRef.current.click()}>Add Bulk Items</Button>
        <strong>
          <a
            href="https://material-depot-content-files.s3.ap-south-1.amazonaws.com/Mysite/pro_forma_bulk_example.xlsx"
            download
          >
            Download Sample File
          </a>
        </strong>
      </Space>
      <input
        type="file"
        accept=".xlsx"
        onChange={(e) => {
          const file = e.target.files[0];
          handleFile(file);
        }}
        style={{ width: 1, height: 1, opacity: 0, overflow: "hidden" }}
        ref={inputRef}
      />
    </Space>
  );
};

export default XLSXReader;
